import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';

function CardSection(_param) {
    var { children , flex , flexContent , className , spacing ='l'  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "flex",
        "flexContent",
        "className",
        "spacing"
    ]);
    return /*#__PURE__*/ React__default.createElement("div", swcHelpers.extends({
        className: classnames('card-section', `card-section--spacing-${spacing}`, className, {
            'card-section--flex': flex,
            'card-section--flex-content': flexContent
        })
    }, rest), children);
}

export { CardSection as default };
//# sourceMappingURL=CardSection.js.map
